<template>
<div class="chapter">
<div class="inner_page">
<div id="container">
<img alt="Page 3" class="back" src="images/graphics_3.jpg"/>
<div class="text"><div style="position:absolute;-webkit-transform:matrix(1.000000, 0.0000, 0.0000, 1.000000, 0,0);width:738px"><div><div style="position:absolute;-webkit-transform:matrix(1.0000, 0.0000, 0.0000, 1.0101, 304.0587, 314.7481);-webkit-transform-origin: 0px 20.788692px;height:0px;"><span class="s0ff s1fs " style="position:absolute;left:0px;width:59px">Latifa</span> <span class="s0ff s1fs s2ls" style="position:absolute;left:60px;width:55px">Berry</span> <span class="s0ff s1fs s3ls" style="position:absolute;left:116px;width:57px">Kropf </span></div>
<div style="position:absolute;-webkit-transform:matrix(1.0000, 0.0000, 0.0000, 1.0101, 257.4464, 344.8994);-webkit-transform-origin: 0px 20.788692px;height:0px;"><span class="s0ff s1fs s4ls" style="position:absolute;left:0px;width:124px">photographs</span> <span class="s0ff s1fs s5ls" style="position:absolute;left:126px;width:26px">by</span> <span class="s0ff s1fs s6ls" style="position:absolute;left:154px;width:39px">Tod</span> <span class="s0ff s1fs s3ls" style="position:absolute;left:196px;width:65px">Cohen </span></div>
</div>
</div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pg_3.vue?0afb48db